import React, { useContext, type FC } from "react";

import "glightbox/dist/css/glightbox.min.css";
import dynamic from "next/dynamic";
import { FontSizeContext } from "../FontSizeContext";
import { type Poll } from "~/lib/db/poll";
import {
  includesClassicEditor,
  type PostContentBlocksType,
} from "~/utils/postUtils";
import { parse } from "@wordpress/block-serialization-spec-parser";
import Blocks from "./Blocks";

const GLightBoxComponent = dynamic(() => import("../GLightBoxComponent"), {
  ssr: false,
});

type PostContentProps = {
  htmlContent: string;
  polls: Poll[];
  textStyle: object;
  indexArticle: number;
};

const replaceNbsps = (str: string) => {
  const re = new RegExp(String.fromCharCode(160), "g");
  return str.replace(re, " ");
};

const replaceContent = (htmlContent: string) => {
  let content = htmlContent.replace(
    /https:\/\/wp-bs\.buddismoesocieta\.org(?!.*\/site)/g,
    "https://buddismoesocieta.org"
  );
  content = content.replace(
    /https:\/\/buddismoesocieta\.org\/numero\/\?issue=/g,
    "https://buddismoesocieta.org/n/"
  );
  content = content.replace(
    /https:\/\/buddismoesocieta\.org\/article\//g,
    "https://buddismoesocieta.org/a/"
  );
  content = content.replace(
    /https:\/\/dev.buddismoesocieta\.org\/article\//g,
    "https://buddismoesocieta.org/a/"
  );
  content = content.replace(/\[et_pb_[a-z-A-Z]*.*\]/g, "");
  content = replaceNbsps(content);
  return content;
};

const PostContent: FC<PostContentProps> = ({
  htmlContent,
  polls,
  textStyle,
  indexArticle,
}) => {
  const { fontSize } = useContext(FontSizeContext);
  htmlContent = replaceContent(htmlContent);
  const blocks: PostContentBlocksType[] = parse(htmlContent);
  const includeVideoYoutube = htmlContent.match(/wp-block-embed__wrapper/g);

  const postContentCustomStyle = {
    ...textStyle,
    fontSize,
  };
  return (
    <>
      <style>{`blockquote {font-size:${
        Number(fontSize.split("px")[0]) + 2
      }px;}`}</style>
      <GLightBoxComponent />
      <div
        className={`post_content break-words ${
          includeVideoYoutube ? "wp-embed-responsive" : ""
        } is-layout-constrained mx-auto max-w-section leading-loose max-xl:px-4 print:max-w-none print:px-4 print:!text-lg`}
        style={postContentCustomStyle}
      >
        {!includesClassicEditor(htmlContent, "<!-- wp") ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : (
          <Blocks
            blocks={blocks}
            polls={polls}
            idBlock={0}
            father={null}
            indexArticle={indexArticle}
          />
        )}
      </div>
    </>
  );
};

export default PostContent;
